import React, { useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { useGetPdfQRCodeTransactionDetails } from '@app/graphql';
import { AuthContext } from '@app/providers';
import Documents from '@app/modules/transaction-form/documents';
import { DocumentContainer } from '@app/modules/transaction-details/transactions-details-components';
import { BackgroundContainer } from '@app/modules/qr-code/transaction-component';
import {
  Container,
  ListView,
  Loader,
  ListContainer,
  MunicipalityContainer,
  MunicipalityLogo,
  MunicipalityImage,
  InfoBox,
  Infocard,
  Label,
  PrimaryValue,
  Value,
  PropertyContainer,
  PropertyIcon,
  PropertyInfoBox,
  PrimaryInfocard,
  SecondaryInfocard,
  InfoContainer,
  PropertyNotesContainer,
  NotesCard,
  PurchaseValue,
  InvolvedContainer,
  Heading,
  ActivityHeading,
  InvolvedBox,
  InvolvedTitle,
  DetailsBox,
  DetailsCard,
  TaskListContainer,
  TaskListBox,
  ChecklistBox,
  DesktopSideNav,
  ProInfo,
  MunicipalityMobileLogo,
  PurchaseInfocard,
  ActivityLogMobileContainer,
  Error,
  ActivityMobileContainer,
  TitleCompanyLabel,
  TitleCompanyValue,
  DashedSeperator,
  Seperator,
  MlsLinkValue,
  ActivityLogContainer,
} from '@app/modules/transaction-details/transactions-details-components';
import { Icon } from '@app/components';
import ActivityLogList from '@app/modules/activity-log';
import ActivityLogMobile from '@app/modules/activity-log/activity-log-mobile';
import { currencyFormat, useLocation } from '@app/utils';
import moment from 'moment';
import PaymentDue from '@app/modules/payment-due/payment-due';
import SideNav from '@app/modules/transaction-details/transactions-details-sidenav';
import {
  UserDetails,
  PropertyDetails,
  InvolvedInfo,
  ActivityLogInfo,
  PaymentProps,
  ApproverDetails,
  quesType,
  VerifyTaxInfo,
} from '@app/types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding, faFilter } from '@fortawesome/free-solid-svg-icons';
import { UploadDocType } from '@app/types/documents';
import {
  InvolvedDetails,
  TaskListDetails,
  getCheckListUserName,
} from '@app/modules/transaction-details/transactions-details';
import { checkCostItemsPermission } from '@app/utils/permissions';
import { PaymentDueContainer } from '../transaction-form/transactions-form-components';

type Props = {
  transactionId: string;
};
const PropertyIconStyles = {
  height: 46,
  width: 38,
  color: '#6A67CE',
};
export default function QrTransactionDetails() {
  const { transactionId }: Props = useParams();
  const { loading, data } = useGetPdfQRCodeTransactionDetails({
    id: transactionId,
  });
  const { userInfo }: any = useContext(AuthContext);
  const { navigate } = useLocation();
  const [showErrorPage, setShowErrorPage] = useState(false);
  const [showActivityLog, setShowActivityLog] = React.useState(false);
  const [activityLog, setActivityLog] = React.useState<ActivityLogInfo[]>([]);
  const [municipalityDetails, setMunicipalityDetails] = React.useState({
    name: '',
    logo: '',
    waterReadingInst: '',
    inspInst: '',
    inspDoc: '',
    taxProofInst: '',
    verifyTaxInst: '',
    taxRate: '',
  });
  const [creatorDetails, setCreatorDetails] = React.useState<UserDetails>({
    name: '',
    createdOn: '',
    type: '',
    firebaseId: '',
  });
  const [propertyDetails, setPropertyDetails] = React.useState<PropertyDetails>(
    {
      type: '',
      address: '',
      zip: '',
      purchasePrice: '',
      closingDate: '',
      notes: '',
      county: '',
    },
  );
  const [mlsLink, setMlsLink] = React.useState('');
  const [titleCompany, setTitleCompany] = React.useState('');
  const [involvedDetails, setInvolvedDetails] = React.useState<InvolvedInfo>({
    buyers: [],
    sellers: [],
    professionalUsers: [],
    assignmentChecklist: {},
  });
  const [legalDesDetails, setLegalDesDetails] = React.useState({
    user: {},
    userType: '',
    status: '',
    notes: '',
    firebaseId: '',
    completedAt: '',
    showLegalDes: false,
  });
  const [waterReadDetails, setWaterReadDetails] = React.useState({
    user: {},
    userType: '',
    status: '',
    completedAt: '',
    firebaseId: '',
    finalReadingAvailNow: 'no',
    FinalReadingRequested: 'no',
    dateForFinalReading: moment().format('YYYY-MM-DD'),
    image: '',
    fileName: '',
    showWaterReading: false,
  });

  const [additionalQuestions, setAdditionalQuestions] = React.useState<
    quesType
  >({
    completedAt: moment().format('YYYY-MM-DD'),
    status: '',
    userType: '',
    firebaseId: '',
    answers: [],
    user: {},
    showQues: false,
  });
  const [documents, setDocuments] = React.useState<UploadDocType[]>([]);
  const [taxPaymentProof, setTaxPaymentProof] = React.useState({
    image: '',
    fileName: '',
    status: '',
    userType: '',
    completedAt: '',
    firebaseId: '',
    taxPaymentReceiptNumber: '',
    dateofTaxPayment: '',
    user: {},
    showTaxProof: false,
  });

  const [verifyTax, setVerifyTax] = React.useState<VerifyTaxInfo>({
    status: '',
    userType: '',
    completedAt: moment().format('YYYY-MM-DD'),
    firebaseId: '',
    verified: false,
    taxAmount: 0,
    user: {},
    showVerifyTax: false,
    exemptReasons: [],
    exemptDetails: '',
    exemptImage: '',
    fileName: '',
  });

  const [inspectionData, setInspectionData] = React.useState({
    completedAt: moment().format('YYYY-MM-DD'),
    status: '',
    userType: '',
    firebaseId: '',
    user: {},
    image: '',
    fileName: '',
    inspectionNotes: '',
    showInspection: false,
  });
  const [transactionPayments, setTransactionPayments] = React.useState<
    PaymentProps[]
  >([]);
  const [approverDetails, setApproverDetails] = React.useState<ApproverDetails>(
    {
      isApproved: false,
      approvedBy: '',
      approvedDate: '',
      approver: '',
      status: '',
    },
  );
  useEffect(() => {
    if (!loading && data) {
      const { getPdfQRCodeTransactionDetails } = data;
      if (getPdfQRCodeTransactionDetails) {
        const { success, transaction } = getPdfQRCodeTransactionDetails;
        if (success) {
          setApproverDetails({
            approvedBy: transaction.approvedBy,
            approvedDate: transaction.approvedDate,
            isApproved: transaction.isApproved,
            approver: transaction.approvedInfo
              ? transaction.approvedInfo.firstName +
                ' ' +
                transaction.approvedInfo.lastName
              : '',
            status: transaction.status,
          });
          setTransactionPayments(transaction.transactionPayments);
          const {
            municipalityData: {
              waterReading = {},
              inspection = {},
              proofofTaxPayment = {},
              TaxCalculations = {},
            },
          } = transaction;
          setActivityLog(
            transaction && transaction.activityLog
              ? transaction.activityLog
              : [],
          );
          setTitleCompany(transaction.titleCompany || '--');
          setMunicipalityDetails({
            name: transaction.municipalityData.name,
            logo: transaction.municipalityData.logo,
            waterReadingInst: waterReading.instructions,
            inspInst: inspection.instructions,
            inspDoc: inspection.allowUsersToUploadDocs,
            taxProofInst: proofofTaxPayment.instructions,
            verifyTaxInst: TaxCalculations.instructions,
            taxRate: TaxCalculations.rate,
          });
          const {
            creator: { type, firebaseId, user = {} },
          } = transaction;
          if (user) {
            const { firstName, lastName } = user;
            setCreatorDetails({
              name: `${firstName} ${lastName}`,
              createdOn: transaction.createdAt,
              type: type,
              firebaseId: firebaseId,
            });
          }
          setDocuments(transaction.transactionDocuments);
          const {
            property: {
              address,
              city,
              state,
              zipCode,
              purchasePrice,
              closingDate,
              notes,
              type: propertyType,
            },
            countyInfo,
          } = transaction;
          setMlsLink(transaction.mlsLink);
          setPropertyDetails({
            type: propertyType,
            address: `${address}, ${city}, ${state}`,
            zip: zipCode,
            purchasePrice: purchasePrice,
            closingDate: closingDate
              ? moment(closingDate).format('MMM D, YYYY')
              : '--',
            notes: notes,
            county: countyInfo && countyInfo.label ? countyInfo.label : '',
          });
          setInvolvedDetails({
            buyers: transaction.buyers,
            sellers: transaction.sellers,
            professionalUsers: transaction.professionalUsers,
            assignmentChecklist: transaction.assignmentChecklist,
          });
          const { pendingTasks = '' } = transaction;

          loadChecklistData(transaction.assignmentChecklist, pendingTasks);
        } else if (!success) {
          setShowErrorPage(true);
        }
      }
    }
  }, [loading, data]);

  const loadChecklistData = (data: any, pendingTasks: string) => {
    if (data && data.legalDescription) {
      const { legalDescription = {} } = data;
      const {
        user = {},
        userType = '',
        status = '',
        notes = '',
        completedAt = moment().format('YYYY-MM-DD'),
        firebaseId = '',
      } = legalDescription;
      setLegalDesDetails({
        user: user,
        userType: userType,
        status: status,
        notes: notes,
        firebaseId: firebaseId,
        completedAt: completedAt,
        showLegalDes: status ? true : false,
      });
    }
    if (data && data.waterReading) {
      const { waterReading = {} } = data;
      const {
        user = {},
        status = '',
        isFinalReadingAvailNow = 'no',
        isFinalReadingRequested = 'no',
        readingDocuments = [],
        dateForFinalReading = moment().format('YYYY-MM-DD'),
        completedAt = moment().format('YYYY-MM-DD'),
        firebaseId = '',
        userType = '',
      } = waterReading;
      let selectedImage =
        readingDocuments && readingDocuments.length
          ? readingDocuments[0].src
          : '';
      let selectedFileName =
        readingDocuments && readingDocuments.length
          ? readingDocuments[0].name
          : '';

      setWaterReadDetails({
        user: user,
        userType: userType,
        status: status,
        completedAt: completedAt,
        firebaseId: firebaseId,
        finalReadingAvailNow: isFinalReadingAvailNow
          ? isFinalReadingAvailNow
          : 'no',
        FinalReadingRequested: isFinalReadingRequested
          ? isFinalReadingRequested
          : 'no',
        dateForFinalReading: dateForFinalReading
          ? moment(dateForFinalReading).format('YYYY-MM-DD')
          : moment().format('YYYY-MM-DD'),
        image: selectedImage,
        fileName: selectedFileName,
        showWaterReading: status ? true : false,
      });
    }
    if (data && data.additionalQuestions) {
      const { additionalQuestions = {} } = data;
      const {
        completedAt = moment().format('YYYY-MM-DD'),
        firebaseId: additionalQuesfirebaseId = '',
        answers = [],
        status = '',
        user = {},
        userType = '',
      } = additionalQuestions;
      setAdditionalQuestions({
        completedAt: completedAt,
        firebaseId: additionalQuesfirebaseId,
        answers: answers,
        status: status,
        user: user,
        userType: userType,
        showQues: answers && answers.length ? true : false,
      });
    }
    if (data && data.proofofTaxPayment) {
      const { proofofTaxPayment: taxProofData = {} } = data;
      const {
        status: taxProofStatus = '',
        completedAt: taxProofCompletedAt = moment().format('YYYY-MM-DD'),
        firebaseId: taxProoffirebaseId = '',
        taxPaymentReceiptNumber = '',
        dateofTaxPayment = '',
        user: taxProofUser = {},
        userType = '',
        proofofTaxPaymentDocuments = [],
      } = taxProofData;
      const selectedImage =
        proofofTaxPaymentDocuments &&
        proofofTaxPaymentDocuments.length &&
        proofofTaxPaymentDocuments[0].src
          ? proofofTaxPaymentDocuments[0].src
          : '';
      const selectedFileName =
        proofofTaxPaymentDocuments &&
        proofofTaxPaymentDocuments.length &&
        proofofTaxPaymentDocuments[0].name
          ? proofofTaxPaymentDocuments[0].name
          : '';
      setTaxPaymentProof({
        image: selectedImage,
        fileName: selectedFileName,
        status: taxProofStatus,
        completedAt: taxProofCompletedAt
          ? moment(taxProofCompletedAt).format('MMM D, YYYY')
          : '--',
        firebaseId: taxProoffirebaseId,
        taxPaymentReceiptNumber: taxPaymentReceiptNumber,
        dateofTaxPayment: dateofTaxPayment,
        user: taxProofUser,
        userType: userType,
        showTaxProof: taxProofStatus ? true : false,
      });
    }
    if (data && data.inspection) {
      const { inspection: inspectionObj = {} } = data;
      const {
        completedAt: inspCompletedAt = moment().format('YYYY-MM-DD'),
        user: inspUser = {},
        firebaseId: inspfirebaseId = '',
        status: inspStatus = '',
        inspectionNotes = '',
        userType = '',
        inspectionDocuments = [],
      } = inspectionObj;
      setInspectionData({
        completedAt: inspCompletedAt
          ? moment(inspCompletedAt).format('MMM D, YYY')
          : '--',
        status: inspStatus,
        firebaseId: inspfirebaseId,
        user: inspUser,
        userType: userType,
        image:
          inspectionDocuments && inspectionDocuments.length
            ? inspectionDocuments[0].src
            : '',
        fileName:
          inspectionDocuments && inspectionDocuments.length
            ? inspectionDocuments[0].name
            : '',
        inspectionNotes: inspectionNotes,
        showInspection: inspStatus ? true : false,
      });
    }
    if (data && data.verifyTaxCalculations) {
      const { verifyTaxCalculations = {} } = data;
      const {
        status = '',
        userType = '',
        firebaseId = '',
        user = {},
        taxAmount = 0,
        completedAt = moment().format('YYYY-MM-DD'),
        verified = false,
        exemption = {},
      } = verifyTaxCalculations;

      setVerifyTax({
        status: status ? status : '',
        completedAt: completedAt ? completedAt : moment().format('YYYY-MM-DD'),
        firebaseId: firebaseId,
        taxAmount: taxAmount,
        user: user,
        userType: userType ? userType : '',
        verified: verified,
        showVerifyTax: status ? true : false,
        exemptReasons:
          exemption && exemption.reasons && exemption.reasons.length
            ? exemption.reasons
            : [],
        exemptDetails: exemption && exemption.details ? exemption.details : '',
        exemptImage:
          exemption &&
          exemption.exemptionDocuments &&
          exemption.exemptionDocuments.length
            ? exemption.exemptionDocuments[0].src
            : '',
        fileName:
          exemption &&
          exemption.exemptionDocuments &&
          exemption.exemptionDocuments.length
            ? exemption.exemptionDocuments[0].name
            : '',
      });
    }
  };

  /**
   * to open mls connection link
   */
  const openMlsLink = () => {
    window.open(mlsLink);
  };

  /**
   *
   * @param filesData document files
   */
  function getFiles(filesData: UploadDocType[]) {}

  /**
   *
   * @param filesData document files
   */
  function afterRemove() {}

  /**
   *
   * @param data data of user
   * @param i index
   * @returns filtered user
   */
  const filterUser = (data: any, i: number) => {
    return data.user !== null;
  };
  return (
    <>
      <BackgroundContainer>
        <Container>
          {loading ? (
            <Loader>
              <Icon name="loader" />
            </Loader>
          ) : showErrorPage ? (
            <Error>
              Something went wrong...
              <div onClick={() => navigate('/transactions')}>Go to home</div>
            </Error>
          ) : (
            <>
              <DesktopSideNav>
                <SideNav
                  userInfo={userInfo}
                  setShowActivityLog={setShowActivityLog}
                />
              </DesktopSideNav>
              {showActivityLog ? (
                <ActivityLogContainer id="activityLogDetails">
                  <ActivityHeading>
                    <div>Activity Log</div>
                  </ActivityHeading>
                  <ActivityLogList activityLog={activityLog} />
                </ActivityLogContainer>
              ) : (
                <ListView id="transactionDetailContainer">
                  <ListContainer id="municipalityDetails">
                    <MunicipalityContainer>
                      <MunicipalityLogo>
                        <MunicipalityImage image={municipalityDetails.logo} />
                      </MunicipalityLogo>
                      <InfoBox>
                        <Infocard>
                          <Label>Municipality</Label>
                          <PrimaryValue>
                            {municipalityDetails.name}
                          </PrimaryValue>
                        </Infocard>
                        <PrimaryInfocard>
                          <Label>Transaction Created by</Label>
                          <Value>
                            {`${creatorDetails.name} on ${
                              creatorDetails.createdOn
                                ? moment(creatorDetails.createdOn).format(
                                    'MMM D, YYYY',
                                  )
                                : '--'
                            }`}
                          </Value>
                        </PrimaryInfocard>
                        {approverDetails.isApproved && (
                          <PrimaryInfocard>
                            <Label>Transaction Approved by</Label>
                            <Value>
                              {`${approverDetails.approver} on ${
                                approverDetails.approvedDate
                                  ? moment(approverDetails.approvedDate).format(
                                      'MMM D, YYYY hh:mm A',
                                    )
                                  : '--'
                              }`}
                            </Value>
                          </PrimaryInfocard>
                        )}
                      </InfoBox>
                      <MunicipalityMobileLogo>
                        <MunicipalityImage image={municipalityDetails.logo} />
                      </MunicipalityMobileLogo>
                    </MunicipalityContainer>
                    <PropertyContainer id="propertyDetails">
                      <PropertyIcon>
                        <FontAwesomeIcon
                          icon={faBuilding}
                          style={PropertyIconStyles}
                        />
                      </PropertyIcon>
                      <InfoContainer>
                        <PropertyInfoBox>
                          <Infocard>
                            <Label>Property Info</Label>
                            <PrimaryValue>{propertyDetails.type}</PrimaryValue>
                            <Value>{propertyDetails.address},</Value>
                            <Value>{propertyDetails.zip}</Value>
                          </Infocard>
                          <ProInfo>
                            <PurchaseInfocard>
                              <Label>Purchase Price </Label>
                              <PurchaseValue>
                                {propertyDetails.purchasePrice.includes('$')
                                  ? propertyDetails.purchasePrice
                                  : `$${currencyFormat(
                                      propertyDetails.purchasePrice,
                                    )}`}
                              </PurchaseValue>
                            </PurchaseInfocard>
                            <SecondaryInfocard>
                              <Label>Closing Date </Label>
                              <Value>{propertyDetails.closingDate}</Value>
                            </SecondaryInfocard>
                          </ProInfo>
                        </PropertyInfoBox>
                        <PropertyNotesContainer>
                          <NotesCard>
                            <Label>Notes</Label>
                            <Value>
                              {propertyDetails.notes
                                ? propertyDetails.notes
                                : '- -'}
                            </Value>
                          </NotesCard>
                        </PropertyNotesContainer>
                        <PropertyNotesContainer>
                          <NotesCard>
                            <Label>MLS Link</Label>
                            <MlsLinkValue onClick={() => openMlsLink()}>
                              {mlsLink || '--'}
                            </MlsLinkValue>
                          </NotesCard>
                        </PropertyNotesContainer>
                      </InfoContainer>
                    </PropertyContainer>
                    <DocumentContainer id="documentsDetails">
                      <Documents
                        fromEditPage={true}
                        uploadedDocs={documents}
                        getFiles={getFiles}
                        afterRemove={afterRemove}
                        isApproved={true}
                      />
                      <Seperator />
                    </DocumentContainer>
                    <InvolvedContainer id="involvedDetails">
                      <Heading>Who is Involved?</Heading>
                      <TitleCompanyLabel>Title Company</TitleCompanyLabel>
                      <TitleCompanyValue>{titleCompany}</TitleCompanyValue>
                      <DashedSeperator />
                      <InvolvedBox>
                        <InvolvedTitle>Buyer Details</InvolvedTitle>
                        <DetailsBox>
                          {involvedDetails.buyers.map((data, i) => {
                            return (
                              <DetailsCard key={i}>
                                <InvolvedDetails
                                  name={data.name}
                                  email={data.email}
                                  phone={data.phone}
                                  address={data.address}
                                  subDetails={data.subDetails}
                                />
                              </DetailsCard>
                            );
                          })}
                        </DetailsBox>
                      </InvolvedBox>

                      <InvolvedBox>
                        <InvolvedTitle>Seller Details</InvolvedTitle>
                        <DetailsBox>
                          {involvedDetails.sellers.map((data, i) => {
                            return (
                              <DetailsCard key={i}>
                                <InvolvedDetails
                                  name={data.name}
                                  email={data.email}
                                  phone={data.phone}
                                  address={data.address}
                                  subDetails={data.subDetails}
                                />
                              </DetailsCard>
                            );
                          })}
                        </DetailsBox>
                      </InvolvedBox>

                      <InvolvedBox>
                        <InvolvedTitle>
                          Professional Users Details
                        </InvolvedTitle>
                        <DetailsBox>
                          {involvedDetails.professionalUsers
                            .filter(filterUser)
                            .map((data, i) => {
                              return (
                                <DetailsCard key={i}>
                                  <InvolvedDetails
                                    name={` ${data.user.firstName} ${data.user.lastName}`}
                                    email={`${data.type}, ${data.user.company}`}
                                    phone={
                                      data.user.phone ? data.user.phone : '- -'
                                    }
                                    address={data.user.email}
                                    subDetails={data.subDetails}
                                  />
                                </DetailsCard>
                              );
                            })}
                        </DetailsBox>
                      </InvolvedBox>
                    </InvolvedContainer>
                    <TaskListContainer id="checklistDetails">
                      <Heading>Task Checklist</Heading>
                      <TaskListBox>
                        {legalDesDetails.showLegalDes && (
                          <ChecklistBox
                            color={
                              legalDesDetails.status === 'COMPLETED'
                                ? 'success'
                                : 'secondary'
                            }>
                            <TaskListDetails
                              title="Legal Description"
                              name={getCheckListUserName(
                                legalDesDetails.user,
                                creatorDetails,
                                involvedDetails,
                              )}
                              status={legalDesDetails.status}
                              showButton={false}
                              date={
                                legalDesDetails.status === 'COMPLETED'
                                  ? legalDesDetails.completedAt
                                    ? moment(
                                        legalDesDetails.completedAt,
                                      ).format('MMM D, Y')
                                    : ''
                                  : ''
                              }
                            />
                          </ChecklistBox>
                        )}
                        {verifyTax.showVerifyTax && (
                          <ChecklistBox
                            color={
                              verifyTax.status === 'COMPLETED'
                                ? 'success'
                                : 'secondary'
                            }>
                            <TaskListDetails
                              title="Verify Tax Calculations"
                              name={getCheckListUserName(
                                verifyTax.user,
                                creatorDetails,
                                involvedDetails,
                              )}
                              status={verifyTax.status}
                              showButton={false}
                              date={
                                verifyTax.status !== 'COMPLETED'
                                  ? ''
                                  : verifyTax.completedAt
                                  ? moment(verifyTax.completedAt).format(
                                      'MMM DD, Y',
                                    )
                                  : ''
                              }
                            />
                          </ChecklistBox>
                        )}
                        {waterReadDetails.showWaterReading && (
                          <ChecklistBox
                            color={
                              waterReadDetails.status === 'COMPLETED'
                                ? 'success'
                                : 'secondary'
                            }>
                            <TaskListDetails
                              title="Water Reading"
                              name={getCheckListUserName(
                                waterReadDetails.user,
                                creatorDetails,
                                involvedDetails,
                              )}
                              status={waterReadDetails.status}
                              showButton={false}
                              date={
                                waterReadDetails.status !== 'COMPLETED'
                                  ? ''
                                  : waterReadDetails.completedAt
                                  ? waterReadDetails.completedAt
                                  : ''
                              }
                            />
                          </ChecklistBox>
                        )}
                        {inspectionData.showInspection && (
                          <ChecklistBox
                            color={
                              inspectionData.status === 'COMPLETED'
                                ? 'success'
                                : 'secondary'
                            }>
                            <TaskListDetails
                              title="Inspection"
                              name={getCheckListUserName(
                                inspectionData.user,
                                creatorDetails,
                                involvedDetails,
                              )}
                              status={inspectionData.status}
                              showButton={false}
                              date={
                                inspectionData.status === 'COMPLETED'
                                  ? inspectionData.completedAt
                                  : ''
                              }
                            />
                          </ChecklistBox>
                        )}

                        {additionalQuestions.showQues && (
                          <ChecklistBox
                            color={
                              additionalQuestions.status === 'COMPLETED'
                                ? 'success'
                                : 'secondary'
                            }>
                            <TaskListDetails
                              title="Additional Questions"
                              name={getCheckListUserName(
                                additionalQuestions.user,
                                creatorDetails,
                                involvedDetails,
                              )}
                              date={
                                additionalQuestions.status === 'COMPLETED'
                                  ? additionalQuestions.completedAt
                                  : ''
                              }
                              status={additionalQuestions.status}
                              showButton={false}
                            />
                          </ChecklistBox>
                        )}
                        {taxPaymentProof.showTaxProof && (
                          <ChecklistBox
                            color={
                              taxPaymentProof.status === 'COMPLETED'
                                ? 'success'
                                : 'secondary'
                            }>
                            <TaskListDetails
                              title="Proof of Tax Payment"
                              name={getCheckListUserName(
                                taxPaymentProof.user,
                                creatorDetails,
                                involvedDetails,
                              )}
                              status={taxPaymentProof.status}
                              showButton={false}
                              date={
                                taxPaymentProof.status === 'COMPLETED'
                                  ? taxPaymentProof.completedAt
                                  : ''
                              }
                            />
                          </ChecklistBox>
                        )}
                      </TaskListBox>
                    </TaskListContainer>
                    {checkCostItemsPermission(userInfo) ? (
                      <PaymentDueContainer
                        fromDetailsPage={true}
                        id="paymentDetails">
                        <Heading>Payment Due</Heading>
                        <PaymentDue
                          payments={transactionPayments}
                          userInfo={userInfo}
                          allowEdit={false}
                          transactionId={transactionId}
                          fromDetailsTab={true}
                          activityLog={activityLog}
                          setCostItems={setTransactionPayments}
                          setActivityLog={setActivityLog}
                        />
                      </PaymentDueContainer>
                    ) : null}
                    <ActivityLogMobileContainer>
                      <ActivityHeading>
                        <div>Activity Log</div>
                        <div>
                          <FontAwesomeIcon icon={faFilter} size="1x" />
                        </div>
                      </ActivityHeading>
                      <ActivityMobileContainer>
                        <ActivityLogMobile logs={activityLog} />
                      </ActivityMobileContainer>
                    </ActivityLogMobileContainer>
                  </ListContainer>
                </ListView>
              )}
            </>
          )}
        </Container>
      </BackgroundContainer>
    </>
  );
}
